export default {
  role: {
    roleId: '역할 ID',
    roleName: '역할 이름',
    description: '역할 설명',
    role: "역할"
  }
};
